import { object, string, array, boolean } from "yup";
import getPartialValidationSchemaAdmin from "./partial-validation-schema-admin";

export default ({ intl, hasAdminPrivileges }) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });

  return object().shape({
    title: string().required(requiredText),
    description: string().required(requiredText),
    keywords: array().of(string().required(requiredText)),
    visible: boolean().required(requiredText),
    billable: boolean().required(requiredText),
    isInternalTest: boolean(),
    ...getPartialValidationSchemaAdmin({ intl, hasAdminPrivileges }),
  });
};
